function renudeIframeLoaded() {}

(function () {
  if (window.location.href.includes('ai-skin-analysis')) {
    var pageTitle = document.querySelector('.page-title__title');
    if (pageTitle) {
      pageTitle.remove();
    }
  }

  window.addEventListener(
    'message',
    function (e) {
      var iframe = document.getElementById('renude-analysis');
      if (!iframe || e.source !== iframe.contentWindow) {
        return;
      }
      if (!Array.isArray(e.data)) {
        return;
      }

      var eventName = e.data[0];
      var data = e.data[1];

      function replyToIframe(payload) {
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage(['addToCartComplete', payload], '*');
        }
      }

      function openCartDrawer() {
        var cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }

      function notifyThemeCartUpdate(itemCount) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: 'renude-analysis',
              data: {
                source: 'renude-analysis',
                itemCount: itemCount,
                sections: {},
              },
            },
          })
        );
      }

      function createCartWithCustomAttributes(
        sessionId,
        businessId,
        productId,
        mentionedProductId
      ) {
        mentionedProductId = mentionedProductId || [];
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            updateCartAttributes(sessionId, businessId, mentionedProductId);
          })
          .catch(function (error) {
            console.error('Error checking cart:', error);
          });
      }

      function updateCartAttributes(
        sessionId,
        businessId,
        mentionedProductId
      ) {
        var updates = {
          attributes: {
            session_id: sessionId,
            business_id: businessId,
            mentionedProductId: mentionedProductId,
          },
        };

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (res) {
            console.log('Cart attributes updated:', res);
          })
          .catch(function (error) {
            console.error('Error updating cart attributes:', error);
          });
      }

      switch (eventName) {
        case 'setHeight':
          iframe.height = data;
          break;
        case 'setTopByWindow':
          window.scrollTo({ top: data, behavior: 'smooth' });
          break;
        case 'setTopByIframe':
          iframe.scrollIntoView({ behavior: 'smooth', block: 'start' });
          break;
        case 'showModal':
          window.scrollTo({ top: 750, behavior: 'smooth' });
          break;
        case 'renude-setup-track':
          var payloadData = JSON.parse(data);
          createCartWithCustomAttributes(
            payloadData.session_id,
            payloadData.BID,
            payloadData.external_id,
            payloadData.mentionedProductId
          );
          break;
        case 'addToCart':
          if (!window.Shopify || !window.Shopify.routes) {
            console.warn('Shopify routes not available for addToCart');
            return;
          }

          var payload;
          try {
            payload = typeof data === 'string' ? JSON.parse(data) : data;
          } catch (err) {
            console.error('addToCart: invalid JSON', err);
            return;
          }

          if (
            !payload ||
            !payload.items ||
            !payload.items.length ||
            !payload.requestId
          ) {
            replyToIframe({
              requestId: payload && payload.requestId,
              ok: false,
              error: 'Invalid addToCart payload',
            });
            return;
          }

          var lineItems = payload.items.map(function (row) {
            var variantId = row.id;
            var numericId = Number(variantId);

            if (!Number.isNaN(numericId)) {
              variantId = numericId;
            }

            return {
              id: variantId,
              quantity:
                row.quantity != null && row.quantity !== ''
                  ? Number(row.quantity)
                  : 1,
            };
          });

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: lineItems }),
          })
            .then(function (response) {
              return response.json().then(function (body) {
                if (!response.ok) {
                  var message =
                    (body && (body.description || body.message)) ||
                    response.statusText;
                  throw new Error(message || 'cart/add failed');
                }

                return body;
              });
            })
            .then(function () {
              var itemCount = lineItems.reduce(function (total, item) {
                return total + (Number(item.quantity) || 0);
              }, 0);

              replyToIframe({ requestId: payload.requestId, ok: true });
              notifyThemeCartUpdate(itemCount);
              openCartDrawer();
            })
            .catch(function (error) {
              console.error('addToCart / cart/add.js:', error);
              replyToIframe({
                requestId: payload.requestId,
                ok: false,
                error: String((error && error.message) || error),
              });
            });
          break;
        default:
          break;
      }
    },
    false
  );
})();
